/* eslint-disable @typescript-eslint/no-unused-vars */
import { Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { Settings } from '../models/common.model';
import { CommonService } from './common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagingService } from './messaging.service';
import { RuntimeConfigService } from './runtimeConfig.service';
import { ToasterService } from './toaster.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  directAccessToken: string | null = null;
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private commonService: CommonService,
    private _messagingService: MessagingService,
    private router: Router,
    private config: RuntimeConfigService,
    private _toasterService: ToasterService,
    private _translateService: TranslateService,
    private titleService: Title,
    private route: ActivatedRoute
  ) {}

  script = document.createElement('script');
  async setUpGoogleScript(): Promise<void> {
    setTimeout(() => {
      // Set Google Api keY DYNAMICALLY
      const head = document.getElementsByTagName('body')[0];
      const apiKey = this.config.googleApiKey;

      if (!document.getElementById('testScriptName')) {
        this.script.type = 'text/javascript';
        this.script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,drawing,geometry,visualization&language=en`;
        this.script.id = 'newTestScriptName';
        this.script.async = true;
        head.appendChild(this.script);
      }
    }, 100);
  }

  api: any;
  projectSettings: any;

  async load(): Promise<void> {
    //multitennat to single tenant
    
    // const res = await this.verifyTenantUrl();
    // if (!res?.isVerfied) {
    //   localStorage.clear();
    //   this.router.navigate(['/not-verified']);
    // } else if (res.isVerfied && (res.status === 2 || res.status === 4 || res.status === 5)) {
    //   this.router.navigate(['/not-verified']);
    //   this._toasterService.errToastr(
    //     this._translateService.instant('Subscription not found. Please contact the admin.')
    //   );
    // } 
    // if (res.isVerfied) {
    // ✅ only when verified and status is not 2,4,5
    // this.router.navigate(['/auth/login']);
    this.setData();
    this.api = `${environment.base_url}settings`;
    await this.getGreatSettings();
    this._messagingService.startMessaging();
    // }
  }
  //multitennat to single tenant

  // async verifyTenantUrl(): Promise<any> {
  //   try {
  //     const url = window.location.origin;
  //     const response: any = await this.http
  //       .post(`${environment.slugVerifyUrl}admin/tenant/verifyUrl`, { url })
  //       .toPromise();

  //     return response?.data; // return full data instead of boolean
  //   } catch (error) {
  //     console.error('Tenant verification failed:', error);
  //     return null;
  //   }
  // }

  async getGreatSettings(): Promise<void> {
    const res = await this.http.get<{ data: Settings }>(this.api).toPromise();
    if (res?.data) {
      this.commonService.settingsSubject.next(res.data);
      this.projectSettings = res.data;
      this.setData();
    }
  }

  setData(): void {
    localStorage.setItem('webSettings', JSON.stringify(this.projectSettings));

    setTimeout(() => {
      const settings = this.projectSettings;
      if (!settings) return;

      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      const setCSSVariable = (
        key: string,
        value: string | null | undefined
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      ) => {
        if (value) document.documentElement.style.setProperty(key, value);
      };

      // Set CSS Variables
      setCSSVariable('--c_primary', settings.theme || settings.colorCodes);
      setCSSVariable('--c_secondary', settings.buttonPrimary);
      setCSSVariable('--c_secondary_txt', settings.buttonTextColor);

      // Set Favicon
      this.setElementAttribute('appFavicon', 'href', settings.favIcon);

      // Set Title
      if (settings.appName) {
        this.titleService.setTitle(settings.appName);
      }

      // Set Logos
      this.setElementAttribute('appLogo', 'src', settings.appLogo);
      this.setElementAttribute('webLogo', 'src', settings.webLogo);
    }, 1000);
  }

  private setElementAttribute(id: string, attr: string, value?: string): void {
    if (!value) return;
    const el = this._document.getElementById(id);
    if (el) el.setAttribute(attr, value);
  }
}
